import { AccountStatus, AccountLinks } from './user';

type BBAppUserKind =
  | 'repository_access_token'
  | 'project_access_token'
  | 'workspace_access_token'
  | 'forge_app';

type BBAppUser = {
  account_id: string;
  account_status: AccountStatus;
  created_on: string;
  display_name: string;
  kind: AppUserKind;
  links: AccountLinks;

  type: 'app_user';
  uuid: string;
};

declare global {
  namespace BB {
    type AppUser = BBAppUser;
  }
}

export type AppUser = BBAppUser;
export type AppUserKind = BBAppUserKind;
